<template>
    <tr class="form__listselect_table_item">
        <td
            v-for="(value, key) of item"
            :key="key"
            :class="`form__listselect_table_${key}`"
        >
            <template v-if="key === 'status'">
                <component-status :status="value"/>
            </template>
            <template v-else>
                {{ value }}
            </template>
        </td>
        <td class="form__listselect_table_actions" v-if="actionsVisible">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :theme="isSelected ? 'tertiary' : 'default'"
                        @click="emitSelected"
                        :name="'form-listselect-table-actions-select'"
                    >{{ isSelected ? $t('forms.listSelect.buttons.selected') : $t('forms.listSelect.buttons.select') }}
                    </component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: { ComponentButton, ComponentStatus },
  name: 'form-list-select-table-item',
  data () {
    return {
      isSelected: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    actionsVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    unselect: function () {
      this.$emit('emit-unselected', this.itemId)
      this.isSelected = false
    },
    emitSelected: function () {
      if (this.isSelected === true) {
        this.$emit('emit-unselected', this.itemId)
        this.isSelected = false
      } else {
        this.$emit('emit-selected', this.itemId)
        this.isSelected = true
      }
    }
  }
}
</script>
